'use strict';

module.exports = function bindTextInputs(selector1, selector2) {
	window.jQuery(selector1).on('keyup change', function () {
		window.jQuery(selector2).val(window.jQuery(this).val());
	});
	window.jQuery(selector2).on('keyup change', function () {
		window.jQuery(selector1).val(window.jQuery(this).val());
	});
};
